import {initFlatPickerInput} from "../../helpers/inputs/flatPicker/flatPicker";
import Axios from "axios";
import handleAjaxError from "../../helpers/handleAjaxError";
import {loading, stopLoading} from "../../helpers/loading";

function initCheckinsReport() {
	// Init date selects
	const fromInput = document.querySelector('input[name="from"]');
	const toInput = document.querySelector('input[name="to"]');
	/** @var {HTMLSelectElement} */
	const productionIdSelect = document.querySelector('select[name="production_id"]');

	const fromInputFlatPickerInstance = initFlatPickerInput(fromInput, {
		autoFillDefaultTime: true,
	});
	const toInputFlatpickerInstance = initFlatPickerInput(toInput, {
		autoFillDefaultTime: false,
	});

	// Default to empty
	toInputFlatpickerInstance.clear();

	// Setup clear button
	const clearToInputButton = document.querySelector('.clear-to-button');
	clearToInputButton.addEventListener('click', () => {
		toInputFlatpickerInstance.clear();
	})

	// Setup download button
	const downloadButton = document.querySelector('.get-report-button')
	downloadButton.addEventListener('click', () => {
		handleDownloadRequest();
	})

	// Setup production change handler
	productionIdSelect.addEventListener('change', () => {
		const selectedOption = productionIdSelect.selectedOptions[0];
		if (selectedOption.dataset.startDate && selectedOption.dataset.endDate) {
			handleProductionChange(selectedOption.dataset.startDate, selectedOption.dataset.endDate)
		}
	})

	// Inital render
	productionIdSelect.dispatchEvent(new InputEvent('change'));

	/** Methods */

	function handleProductionChange(startDate, endDate) {
		fromInputFlatPickerInstance.setDate(startDate, true);
		toInputFlatpickerInstance.setDate(endDate, true);
	}

	function handleDownloadRequest() {
		// First test if we can get an actual file
		// from the given dates
		const testUrl = new URL(downloadButton.dataset.testRoute);
		testUrl.searchParams.set('from', fromInput.value);
		testUrl.searchParams.set('to', toInput.value);
		testUrl.searchParams.set('production_id', productionIdSelect.value);

		loading();

		Axios.post(testUrl.toString())
			.then(() => {
				// We can, open download in new tab
				const downloadUrl = new URL(downloadButton.dataset.downloadRoute);
				downloadUrl.searchParams.set('from', fromInput.value);
				downloadUrl.searchParams.set('to', toInput.value);
				downloadUrl.searchParams.set('production_id', productionIdSelect.value);

				window.open(downloadUrl.toString(), '_blank')
			})
			.catch(handleAjaxError)
			.finally(stopLoading)

	}
}

export {
	initCheckinsReport
}
